import { IconSize } from "../../content/Icon/consts";

export type IconButtonSize = "small" | "medium" | "large" | "xlarge";

export const sizeMap: {
  [key in IconButtonSize]: {
    circleSize: string;
    iconSize: IconSize;
  };
} = {
  small: {
    circleSize: "32px",
    iconSize: "large"
  },
  medium: {
    circleSize: "40px",
    iconSize: "large"
  },
  large: {
    circleSize: "48px",
    iconSize: "large"
  },
  xlarge: {
    circleSize: "60px",
    iconSize: "xlarge"
  }
};
